import { Fragment, useEffect, useState } from "react";
//import { useParams, useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Button, Col, Flex, Form, Image, InputNumber, Result, Row, Select, Tooltip, Typography } from "antd";
import { BarcodeOutlined, DownloadOutlined, PhoneOutlined, WhatsAppOutlined } from "@ant-design/icons";
import { callDownloadPdfTicketsByParams, callGetTicketsByParams } from "../../services/participantsService";
import { showNotificationTopEnd } from "../../util/utils";
import { VERIFIER } from "../../constants/AppConstants";
import { callGetActiveLotto } from "../../services/lottoService";
import NotFound from "../NotFound/NotFound";
import Ticket from "./Ticket/Ticket";

import botargaImage from "../../assets/images/botarga/Rifadito_Saludando.png";
import botargaThinking from "../../assets/images/botarga/Rifadito_Pensando.png";
import botargaNormal from "../../assets/images/botarga/Rifadito_Manos_Cadera.png";
import botargaNervioso from "../../assets/images/botarga/Rifadito_Nervioso.png";

import "./TicketVerifier.css";


const { Title, Text } = Typography;
const { Option } = Select;

export default function TicketVerifier() {
    // const { id } = useParams();
    // const [searchParams] = useSearchParams();
    // const ticket = searchParams.get("ticket");
    const [searchType, setSearchType] = useState("ticket");
    const [data, setData] = useState([]);
    const [lottoData, setLottoData] = useState(null);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [loading, setLoading] = useState(false);
    const [isActiveLotto, setIsActiveLotto] = useState(true);
    const [isError, setIsError] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [selectedPhone, setSelectedPhone] = useState(null);
    const [selectedLada, setSelectedLada] = useState(null);


    useEffect(() => {
        getLottoInfo();
        // eslint-disable-next-line
    }, []);


    const getLottoInfo = async () => {
        const response = await callGetActiveLotto(false);
        if (response?.status === 200) {
            setLottoData(response?.data);
            setIsActiveLotto(true);
            setIsError(false);
        } else {
            if (response?.status === 404) {
                setIsActiveLotto(false);
                setIsError(false);
            } else {
                showNotificationTopEnd("error", "Error, por favor recarga la pagina");
                setIsError(true);
            }
        }
    }


    const handleGetTicketsByParams = async (lottoId, ticketNumber, phone, lada) => {
        setLoading(true);

        const response = await callGetTicketsByParams(lottoId, ticketNumber, phone, lada);
        if (response?.status === 200) {
            setData(response?.data);
            setIsFirstLoad(false);
        } else {
            showNotificationTopEnd("error", "Error, por favor recarga la pagina");
        }
        setLoading(false);
    };


    const handleDownloadPDF = async () => {
        setLoading(true);
        const response = await callDownloadPdfTicketsByParams(lottoData?.lottoId, selectedTicket, selectedPhone, selectedLada, lottoData?.lottoNumber);
        if (response?.status === 200) {
            console.warn("Descarga exitosa");
        } else {
            showNotificationTopEnd("error", "Error al generar el PDF, por favor recarga la pagina");
        }
        setLoading(false);
    };


    const onFinish = (values) => {
        setSelectedTicket(values?.ticket);
        setSelectedPhone(values?.phone);
        setSelectedLada(values?.lada);
        handleGetTicketsByParams(lottoData?.lottoId, values?.ticket, values?.phone, values?.lada);
    };


    return (
        <>
            <Flex className="verifier-section-container">
                <Title className="verifier-section-title" strong>
                    {VERIFIER.TITLE}
                </Title>
            </Flex>
            {isError ? (
                <NotFound
                    title="Oops! Parece que algo salió mal"
                    subtitle="Vuelve a intentarlo en otro momento"
                    description="Mantente informado a través de nuestras redes sociales"
                    image={botargaNervioso}
                />
            ) : (
                <>
                    {isActiveLotto ? (
                        <>
                            <Flex className="verifier-container">
                                <Form form={form} name="horizontal-verifier" layout="inline" onFinish={onFinish}>
                                    <Form.Item label="Buscar por">
                                        <Select value={searchType} onChange={(value) => {
                                            form.resetFields();
                                            setData([]);
                                            setSearchType(value);
                                            setIsFirstLoad(true);
                                        }}>
                                            <Option value="ticket">Buscar por Ticket</Option>
                                            <Option value="phone">Buscar por Teléfono</Option>
                                        </Select>
                                    </Form.Item>

                                    {searchType === "ticket" ? (
                                        <Form.Item
                                            name="ticket"
                                            rules={[{ required: true, message: "El ticket es requerido!" }]}
                                        >
                                            <InputNumber max={10000000} prefix={<Tooltip title="Ticket"><BarcodeOutlined /></Tooltip>} placeholder="Ticket Number" style={{ width: "100%" }} />
                                        </Form.Item>
                                    ) : (
                                        <Row style={{ marginBottom: "8px" }}>
                                            <Col>
                                                <Form.Item
                                                    name="lada"
                                                    rules={[{ required: true, message: "Selecciona la lada" }]}
                                                >
                                                    <Select style={{ width: "100%" }} placeholder="Lada" prefix={<PhoneOutlined style={{ fontSize: 16 }} />}>
                                                        <Option value="52"><span className="fi fi-mx" style={{ marginLeft: 4 }}></span> +52</Option>
                                                        <Option value="1"><span className="fi fi-us" style={{ marginLeft: 4 }}></span> +1</Option>
                                                    </Select>
                                                </Form.Item>
                                            </Col>
                                            <Col>
                                                <Form.Item
                                                    name="phone"
                                                    rules={[{ required: true, message: "El telefono es requerido!" }]}
                                                >
                                                    <InputNumber maxLength={10} minLength={10} prefix={<WhatsAppOutlined />} placeholder="Número de WhatsApp" style={{ width: "100%" }} />
                                                </Form.Item>
                                            </Col>
                                        </Row>

                                    )}
                                    <Form.Item>
                                        <Button
                                            type="primary"
                                            className="load-more-button"
                                            htmlType="submit"
                                            loading={loading}
                                        >
                                            {VERIFIER.BUTTON_VERIFIER}
                                        </Button>
                                    </Form.Item>
                                </Form>
                                {data?.length > 1 && (
                                    <>
                                        <Text>¡Descarga la información de tus tickets en formato PDF!</Text>
                                        <Button loading={loading} type="primary" className="verifier-download-button" icon={<DownloadOutlined />} onClick={() => handleDownloadPDF()}>Descargar</Button>
                                    </>
                                )}
                            </Flex>
                            {isFirstLoad ? (
                                <Flex className="verifier-image-container">
                                    <Image preview={false} src={botargaImage} />
                                </Flex>
                            ) : (
                                data?.length > 0 ? (
                                    <Flex className="verifier-ticket-container">
                                        {Array.isArray(data) && data?.map((item, index) => <Ticket key={index} data={item} />)}
                                    </Flex>
                                ) : (
                                    <Flex className="verifier-image-container">
                                        <Result
                                            style={{ paddingTop: "0px" }}
                                            icon={<Image style={{ maxWidth: "200px" }} preview={false} src={botargaThinking} />}
                                            title={<Title level={1}>Oops!</Title>}
                                            subTitle={
                                                <Fragment>
                                                    {searchType === "ticket" ?
                                                        <Text style={{ fontSize: "20px" }}>{VERIFIER.ERRORS.TITLE_TICKET}</Text> :
                                                        <Text style={{ fontSize: "20px" }}>{VERIFIER.ERRORS.TITLE_PHONE}</Text>
                                                    }
                                                    <br />
                                                    {searchType === "ticket" ?
                                                        <Text style={{ fontSize: "20px" }}>{VERIFIER.ERRORS.DESCRIPTION_TICKET}</Text> :
                                                        <Text style={{ fontSize: "20px" }}>{VERIFIER.ERRORS.DESCRIPTION_PHONE}</Text>
                                                    }
                                                </Fragment>
                                            }
                                            extra={
                                                <Button className="load-more-button" type="primary" onClick={() => navigate("/")}>
                                                    {VERIFIER.BUTTON_LABEL}
                                                </Button>
                                            }
                                        />
                                    </Flex>
                                )
                            )}
                        </>
                    ) : (
                        <NotFound
                            title="Por ahora no tenemos sorteos activos"
                            subtitle="No te pierdas los próximos sorteos"
                            description="Lo anunciaremos próximamente en nuestras redes sociales"
                            image={botargaNormal}
                        />
                    )}
                </>
            )}

        </>
    );
}